<template>
  <div class="navbar-container d-flex align-items-center justify-content-between">
    <!-- Linke Sektion -->
    <div class="navbar-left d-flex align-items-center">
      <ul class="nav navbar-nav d-xl-none">
        <li class="nav-item">
          <b-link
            class="nav-link"
            @click="toggleVerticalMenuActive"
          >
            <feather-icon
              icon="MenuIcon"
              size="28"
            />
          </b-link>
        </li>
      </ul>
      <ul class="nav navbar-nav">
        <li class="nav-item">
          <actions />
        </li>
      </ul>
    </div>

    <!-- Mittlere Sektion: Umgebung Badge -->
    <div class="navbar-center">
      <b-badge
        v-if="processEnv === 'development'"
        variant="warning"
        class="mb-1 env-label"
        style="font-size: 1rem;"
      >
        <div class="d-flex align-items-center">
          <feather-icon
            icon="AlertTriangleIcon"
            class="mr-1"
          />
          <span>Entwicklungsumgebung</span>
        </div>
        <div v-if="processEnv === 'development'">
          <b-link
            class="text-white"
            :href="baseURL"
            target="_blank"
          >
            {{ baseURL }}
          </b-link>
        </div>
      </b-badge>
      
    </div>

    <!-- Rechte Sektion -->
    <b-navbar-nav class="align-items-center ml-auto">
      <dark-toggler class="d-none d-lg-block" />
      <user-dropdown />
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink,
  BNavbarNav,
  BNavItemDropdown,
  BDropdownItem,
  BDropdownDivider,
  BAvatar,
  BRow,
  BCol,
  BBadge,
} from 'bootstrap-vue'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import UserDropdown from './UserDropdown.vue'
import Actions from './Actions.vue'

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
    Actions,
    // Navbar Components
    DarkToggler,
    UserDropdown,
    BBadge,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      processEnv: process.env.NODE_ENV,
      baseURL: process.env.VUE_APP_DATABASE_HOST,
    }
  },
  computed: {
    user() {
      return this.$store.getters.user
    },
    loggedIn() {
      return this.$store.state.authentication.status.loggedIn
    },
  },
  methods: {
    logoutAction() {
      this.$store.dispatch('logoutAction')
      this.$router.push('/login')
    },
    showProfile() {
      this.$router.push(`/users-view/${this.user.id}`)
    },
  },
}
</script>

<style scoped>
.navbar-container {
  width: 100%;
}
.navbar-center {
  flex: 1;
  text-align: center;
  padding-top: 15px;
}
.env-label {
  font-size: 1.2rem;
}
</style>
